import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { drawDOM, exportImage, exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { Popup } from "@progress/kendo-react-popup";
import { formatNumber } from "@telerik/kendo-intl";
import * as moment from "moment";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import AddToCart from "../Tenant/AddToCart";
import { InsertImage } from "./insertImageTool";
import { insertImagePlugin } from "./insertImagePlugin";
import { insertImageFiles } from "./utils";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// import"../../Styles/RichTextChart.scss";

import {
  Editor,
  EditorTools,
  EditorUtils,
  ProseMirror,
} from "@progress/kendo-react-editor";
import SkeletonReport from "./SkeletonReport";
const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript,
  ForeColor,
  BackColor,
  CleanFormatting,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Indent,
  Outdent,
  OrderedList,
  UnorderedList,
  NumberedList,
  BulletedList,
  Undo,
  Redo,
  FontSize,
  FontName,
  FormatBlock,
  Link,
  Unlink,
  // InsertImage,
  ViewHtml,
  InsertTable,
  InsertFile,
  SelectAll,
  Print,
  Pdf,
  AddRowBefore,
  AddRowAfter,
  AddColumnBefore,
  AddColumnAfter,
  DeleteRow,
  DeleteColumn,
  DeleteTable,
  MergeCells,
  SplitCell,
} = EditorTools;
const { EditorState, EditorView, Plugin, PluginKey } = ProseMirror;
const {
  imageResizing,
  tableResizing,
  pasteCleanup,
  sanitize,
  sanitizeClassAttr,
  sanitizeStyleAttr,
  removeAttribute,
  replaceImageSourcesFromRtf,
} = EditorUtils;
const toolsList = [
  [Bold],
  [Italic, Underline, Strikethrough],
  [AlignLeft, AlignCenter, AlignRight, AlignJustify],
  [Subscript, Superscript],
  ForeColor,
  BackColor,
  [CleanFormatting],
  [Indent, Outdent],
  [OrderedList, UnorderedList],
  [NumberedList, BulletedList],
  [SelectAll],
  [Undo, Redo],
  [Link, Unlink, ViewHtml],
  [InsertTable, InsertFile],
  [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
  [DeleteRow, DeleteColumn, DeleteTable],
  [MergeCells, SplitCell],
  FontSize,
  FontName,
  FormatBlock,
  [Pdf],
  [Print],
  [InsertImage],
];
const pasteSettings = {
  convertMsLists: true,
  // stripTags: 'span|font'
  attributes: {
    class: sanitizeClassAttr,
    style: sanitizeStyleAttr,
    // keep `width`, `height` and `src` attributes
    width: () => {},
    height: () => {},
    src: () => {},
    // Removes `lang` attribute
    // lang: removeAttribute,

    // removes other (unspecified above) attributes
    "*": removeAttribute,
  },
};

const styles = `

    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    ::-webkit-scrollbar-track {
      background: #000000;
    }
    ::-webkit-scrollbar-thumb {
      background: #555555 !important;
      border-radius: 10px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #444444;
    }
    html,body{
      font-family: Arial, Helvetica, sans-serif;
    }

    p {
        color: #ffffff;
        font-size:14px;
    }
   
    ul {
      color:  #ffffff;
    }
    li {
      color:  #ffffff;
    }
    .ProseMirror{
      background-color: #0C0C0C;
    }
    
`;
export default class RichTextChart extends Component {
  _chart;
  _chartTemp;
  _editor;
  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      title: "",
      showAddToCart: false,
      editable: false,
      htmlvalue: "",
      autoSave: false,
      SaveValue: false,
      isReportLoaded:false,
      chartData:{},
    };
    this._editor = React.createRef();
    this.openwidgetpopup = this.openwidgetpopup.bind(this);
  }

  componentDidMount=()=>{
    
    if(this.props.dashboardId&&this.props.reportId&&!this.props.chartInputs){
      this.fetchReportsByPagination(this.props.dashboardId,this.props.reportId);
    }else{
      this.setState({
        chartData:this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded:true
      });
      this.onInit(this.props.chartInputs);
    }   }
   fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.setState({
          chartData:response.chartData[0],
          isReportLoaded:true,
          editable: response.chartData[0]?.editable,
        });
        this.onInit(response.chartData[0]);
        this.props.updateResponse(reportId,response.chartData[0]);
      }else{
        this.setState({
          chartData:{},
          isReportLoaded:true
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData:{},
        isReportLoaded:true
      });
    }
  };
  onInit = (chartData) => {
    try {
      // let chartData = this.state.chartData;
      let htmlId = "#c" + chartData.widgetId;
      let gridElement = document.querySelector(htmlId);
      let editor = gridElement.getElementsByClassName("k-editor")[0];
      let iFrame = editor.querySelector("iframe");
      iFrame.contentDocument
        .querySelector(".k-content")
        .setAttribute("contenteditable", this.props.chartInputs.editable);
      // console.log("chartData.editable", chartData);
      this.setState({
        ...this.state,
        editable: chartData.editable,
        chartData:this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded:true
      });
    } catch (err) {
      console.log(err);
    }
  };

  onImageInsert = (args) => {
    const { files, view, event } = args;
    const nodeType = view.state.schema.nodes.image;
    const position =
      event.type === "drop"
        ? view.posAtCoords({
            left: event.clientX,
            top: event.clientY,
          })
        : null;
    insertImageFiles({
      view,
      files,
      nodeType,
      position,
    });
    return files.length > 0;
  };
  getHtml = () => {
    let htmlvalue = "";
    if (this._editor.current) {
      const view = this._editor.current.view;
      console.log("/", view);
      if (view) {
        htmlvalue = EditorUtils.getHtml(view.state);
        console.log("htmlvalue", htmlvalue);
      }
    }
    return htmlvalue;
  };


  onImageExportClick = () => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "bar-chart";

    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    
    // 1. Find the .textnarrativeexport inside this chart
    let narrativeElement = gridElement.querySelector(".textnarrativeexport");

    if (narrativeElement) {
      // 2. Temporarily make it visible
      narrativeElement.style.display = "block";

      // 3. Assign new text value inside the <p> tag
      let pTag = narrativeElement.querySelector("p");
      if (pTag) {
        const narrativeText = this.state.chartData?.textNarrative || "";
        pTag.textContent = narrativeText;
      }
    }
    
    // 4. Create a temporary white background overlay
    const whiteBackground = document.createElement('div');
    whiteBackground.style.position = 'absolute';
    whiteBackground.style.top = '0';
    whiteBackground.style.left = '0';
    whiteBackground.style.width = '100%';
    whiteBackground.style.height = '100%';
    whiteBackground.style.backgroundColor = 'white';
    whiteBackground.style.zIndex = '-1';
    
    // Store original position style
    const originalPosition = gridElement.style.position;
    
    // Make the container positioned so the absolute overlay works
    gridElement.style.position = 'relative';
    
    // Add the white background to the container
    gridElement.appendChild(whiteBackground);
    
    // 5. Create a style element with comprehensive white background rules
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      /* Target the specific container */
      #${gridElement.id} {
        background-color: white !important;
        color: black !important;
        position: relative !important;
      }
      
      /* Target all elements inside the container */
      #${gridElement.id} * {
        background-color: white !important;
        color: black !important;
      }
      
      /* Specific targeting for the dataset header which appears to have a black background */
      #${gridElement.id} .wgHeader {
        background-color: white !important;
        color: black !important;
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
      }
      
      #${gridElement.id} .wgHeader h4 {
        background-color: white !important;
        color: black !important;
        margin: 0 !important;
      }
      
      /* Target the text narrative area */
      #${gridElement.id} .textnarrativeexport {
        background-color: white !important;
        color: black !important;
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
      }
      
      #${gridElement.id} .textnarrativeexport p {
        background-color: white !important;
        color: black !important;
        margin: 0 !important;
      }
      
      /* Target any potential dividers or borders */
      #${gridElement.id} hr,
      #${gridElement.id} .divider {
        background-color: white !important;
        border-color: white !important;
      }
      
      /* Preserve chart colors */
      #${gridElement.id} .mitigated { background-color: rgb(248, 220, 135) !important; }
      #${gridElement.id} .unmitigated { background-color: rgb(255, 138, 130) !important; }
      #${gridElement.id} .mitigatedend { background-color: rgb(255, 210, 70) !important; }
      #${gridElement.id} .umitigatedend { background-color: rgb(255, 99, 88) !important; }
      #${gridElement.id} .originalCompletionDate { background-color: rgb(206,237,248) !important; }
      #${gridElement.id} .projectedCompletionDate { background-color: rgb(227, 241, 22) !important; }
      #${gridElement.id} .actualCompletionDate { background-color: rgb(34,159,204) !important; }
      #${gridElement.id} .currentValue { background-color: rgb(8, 77, 167) !important; }
    `;
    
    // Add the style element to the document head
    document.head.appendChild(styleElement);
    
    // 6. Export immediately
    drawDOM(gridElement, { background: "white" })
      .then((group) => exportImage(group, { background: "white" }))
      .then((dataURI) => {
        saveAs(dataURI, widgetName + ".png");
      })
      .finally(() => {
        // 7. Clean up - remove the white background overlay
        try {
          gridElement.removeChild(whiteBackground);
        } catch (e) {
          console.error("Error removing white background:", e);
        }
        
        // 8. Restore original position
        gridElement.style.position = originalPosition;
        
        // 9. Remove the style element
        try {
          document.head.removeChild(styleElement);
        } catch (e) {
          console.error("Error removing style element:", e);
        }
        
        // 10. Hide the narrative element again
        if (narrativeElement) {
          narrativeElement.style.display = "none";
          let pTag = narrativeElement.querySelector("p");
          if (pTag) {
            pTag.textContent = ""; // clear the text if needed
          }
        }
      });
  };

  onPDFExportClick = () => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "line-chart";
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData?.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    setTimeout(async () => {
      drawDOM(gridElement, {
        //  paperSize: "A4",
        landscape: true,
        title: this.state.title + " " + CreatedDate,
      })
        .then((group) => {
          return exportPDF(group);
        })
        .then((dataURI) => {
          saveAs(dataURI, widgetName + ".pdf");
          // console.log(dataUri.split(";base64,")[1]);
        });
    }, 1000);
    this.pdfTitlePopupClose();
  };
  openWidgetDeletePopup = () => {
    if(!this.props.isFreezeDS){
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId||this.props.reportId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };
  changeLineChartWidth = (widgetId) => {
    this.props.changeLineChartWidth(widgetId);
    let htmlData = this.getHtml();
    this.props.refreshTextWidget(htmlData, widgetId, this.state.editable);
  };
  editWidget = (data) => {
    if (data.isActionWidget) {
      this.refs.childWidget.editWidgetdOpen("MITI", data);
    } else {
      this.refs.childWidget.editWidgetdOpen("RISK", data);
    }
  };

  selectedDB = (data) => {
    this.props.selectedDB(data);
  };

  shareFile = async (e, widgetId) => {
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData?.widgetId;

    

    let widgetName = this.state.chartData
      ? this.state.chartData?.widgetName
      : "line-chart";
    e.preventDefault();
    var pdf = new jsPDF("pt", "px", [595.28, 841.89]);
    var options = {
      width: 400,
      height: 400,
    };

    const input = document.getElementById("c" + chartId);
    const iframe = input.getElementsByTagName("iframe");
    const screen = iframe[0]?.contentDocument?.body;
    const This = this;

    pdf.fromHTML(
      screen,
      60,
      60,
      options,
      function () {
        var base = pdf.output("datauristring"); // base64 string
        console.log(base);
        This.sendMail(base, widgetId);

        //  pdf.save(widgetName+".pdf");
      },
      {
        top: 20,
        bottom: 20,
        right: 20,
        left: 20,
      }
    );
    
  };

  

  sendMail = async (dataURL, widgetId) => {
    const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");
    let widgetName = this.state.chartData
      ? this.state.chartData?.widgetName
      : "Bar-chart";
    var blob = this.dataURLtoFile(dataURL, widgetName + ".pdf");
    console.log("-", dataURL);
    var fd = new FormData(document.forms[0]);
    fd.append("file", blob);
    fd.append("mailId", this.state.emailId);
    fd.append("message", this.state.message);
    fd.append("widgetId", widgetId);
    fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
    fd.append("CreatedDate", CreatedDate);
    fd.append("name", secureLocalStorage.getItem("userName"));
    fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
    this.setState({ ...this.state, loader: true });
    let response = await Api.shareWidgetToUser(fd);
    if (response.status === 200) {
      this.setState({ ...this.state, loader: false, emailId: "", message: "" });
      toastr.success(response.message);
    } else {
      this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
  };

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  moveToHome = async (data) => {
    try {
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  pdfTitlePopupClose = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 1000);
  };
  pdfTitlePopupOpen = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: true,
      isHidden: true,
    });
  };

  refreshDashboard = (flag) => {
    this.props.refreshDashboard(flag);
  };

  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Widget",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }
  ViewDataSet = () => {
    this.setState({
      visible: true,
    });
  };
  closeToggleClose = () => {
    this.setState({
      visible: false,
    });
  };
  formatYaxisValue = (e) => {
    if (this.isFloat(e.value)) {
      return "";
    } else {
      return formatNumber(Number(e.value), "##,#");
    }
  };
  isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  view = null;
  editable = () => this.state.editable;
  onMount = (event) => {
    const iframeDocument = event.dom.ownerDocument;
    const style = iframeDocument.createElement("style");
    style.appendChild(iframeDocument.createTextNode(styles));
    iframeDocument.head.appendChild(style);

    const state = event.viewProps.state;
    const plugins = [...state.plugins, insertImagePlugin(this.onImageInsert)];

    return new EditorView(
      {
        mount: event.dom,
      },
      {
        ...event.viewProps,
        state: EditorState.create({
          doc: state.doc,
          plugins: [...plugins, imageResizing(), ...tableResizing()],
        }),
      }
    );
  };
  widgetdata = async (chartData) => {
    try {
      this.setState({ ...this.state, loader: true });
      let htmlData = await this.getHtml();
      var request = {
        widgetId: chartData.widgetId,
        Name: chartData.name,
        WidgetTypeId: chartData.widgetTypeId ? chartData.widgetTypeId : 8,
        DashBoardId: chartData.dashBoardId,
        DataSource: [0],
        WidgetAxis: {
          XAxisValue: [],
          YAxisValue: [],
        },

        updatedDate: new Date(),
        IsTimestamp: false,
        isOpportunities: false,
        title: chartData.title,
        description: chartData.description,
        textWidgetData: htmlData, //chartData.textWidgetData?chartData.textWidgetData:"<p></p>"
      };

      let response = await Api.saveWidget(request);
      {
        if (response.status === 200) {
          this.toggleEditable(false);
          this.setState({
            ...this.state,
            autoSave: false,
          });
          this.setState({ ...this.state, loader: false });
        } else {
          this.setState({ ...this.state, loader: false });
        }
      }
    } catch (err) {
      console.log(err);
      
    }
  };

  openwidgetpopup = () => {
    this.setState({
      ...this.state,
      autoSave: true,
    });
  };
  closewidgetpopup = () => {
    this.setState({
      ...this.state,
      autoSave: false,
    });
  };
  toggleEditable = (flag) => {
    this.setState((state) => ({
      editable: !state.editable,
    }));
    let chartId = this.state.chartData?.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    let editor = gridElement.getElementsByClassName("k-editor")[0];
    let iFrame = editor.querySelector("iframe");
    iFrame.contentDocument
      .querySelector(".k-content")
      .setAttribute("contenteditable", flag);
  };

  saveTextWidget = async (chartData) => {
    try {
      this.setState({ ...this.state, loader: true });
      this.setState({
        ...this.state,
        SaveValue: true,
      });
      let htmlData = await this.getHtml();
      var request = {
        widgetId: chartData.widgetId,
        Name: chartData.name,
        WidgetTypeId: chartData.widgetTypeId ? chartData.widgetTypeId : 8,
        DashBoardId: chartData.dashBoardId,
        DataSource: [0],
        WidgetAxis: {
          XAxisValue: [],
          YAxisValue: [],
        },
        updatedDate: new Date(),
        IsTimestamp: false,
        isOpportunities: false,
        title: chartData.title,
        description: chartData.description,
        updatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        textWidgetData: htmlData, //chartData.textWidgetData?chartData.textWidgetData:"<p></p>"
      };
      let response = await Api.saveWidget(request);
      {
        if (response.status === 200) {
          toastr.success(response.message);
          this.toggleEditable(false);
          this.setState({ ...this.state, loader: false });
          this.props.refreshTextWidget(htmlData, chartData.widgetId, false);
        } else {
          toastr.error(response.message);
          this.setState({ ...this.state, loader: false });
        }
      }
    } catch (err) {
      console.log(err);
      this.setState({ ...this.state, loader: false });
    }
  };
  handleDownloadImage = () => {
    let widgetName = this.state.chartData
      ? this.state.chartData?.widgetName
      : "line-chart";
    let chartId = this.state.chartData?.widgetId;
    const input = document.getElementById("c" + chartId);
    const iframe = input.getElementsByTagName("iframe");
    const screen = iframe[0]?.contentDocument?.body;
    html2canvas(screen).then((canvas) => {
      const data = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = data;
      link.download = widgetName + ".png";
      document.body.appendChild(link);
      link.click();
    });
  };
  // textPdf = async () => {
  //   let widgetName = this.state.chartData
  //     ? this.state.chartData.widgetName
  //     : "line-chart";
  //   const pdfelement = new jsPDF("pt","mm",[400,280]);
  //   const iframe = document.getElementsByTagName("iframe");
  //   const screen = iframe[0]?.contentDocument?.body;
  //   const canvas = await html2canvas(screen,{scale:2});
  //   {
  //     const imgData = canvas.toDataURL("image/png");

  //     const imgWidth = 200;
  //     const pageHeight = 200;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //     let heightLeft = imgHeight;
  //     let position = 0;
  //     heightLeft -= pageHeight;
  //     pdfelement.addPage();
  //     // pdfelement.setFillColor(24, 26, 26);
  //     // pdfelement.rect(0, 0, 210, 300);
  //     pdfelement.addImage(imgData, "PNG", 20, position, imgWidth, imgHeight);

  //     while (heightLeft <= 0) {
  //       position =heightLeft - imgHeight;
  //       pdfelement.addPage();
  //       // pdfelement.setFillColor(24, 26, 26);
  //       // pdfelement.rect(0, 0, 210, 300
  //       pdfelement.addImage(imgData, "PNG", 20, position, imgWidth, imgHeight);

  //       heightLeft -= pageHeight;

  //     }

  //     pdfelement.deletePage(1);

  //     var pagecount=pdfelement.internal.getNumberOfPages();
  //     for(var i=1;i<=pagecount;i++)
  //     {
  //       pdfelement.setPage(i);
  //       pdfelement.text("page"+ String(i),200-80,300+94,null,null);
  //     }
  //    pdfelement.save(widgetName+".pdf");

  //   }
  // };

  textPdf = async (e) => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "line-chart";
    e.preventDefault();
    var pdf = new jsPDF("pt", "px", [595.28, 841.89]);
    var options = {
      width: 400,
      height: 400,
    };
    let chartId = this.state.chartData?.widgetId;
    const input = document.getElementById("c" + chartId);
    const iframe = input.getElementsByTagName("iframe");
    const screen = iframe[0]?.contentDocument?.body;

    pdf.fromHTML(
      screen,
      70,
      60,
      options,
      function () {
        pdf.save(widgetName + ".pdf");
      },
      {
        top: 20,
        bottom: 20,
        right: 20,
        left: 20,
      }
    );
  };
  render() {
    const chartData = this.state.chartData ? this.state.chartData : {};
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    }else {
    return (
      <div>
        
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}

        {this.props.expandIcon && (
          <div className="expandView">
            <a
              className="expand"
              onClick={() => this.changeLineChartWidth(chartData.widgetId)}
            >
              <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
            </a>
            <a
              className="shrink"
              onClick={() => this.changeLineChartWidth(chartData.widgetId)}
            >
              <img src={Images.SHRINK} alt="Expand" width="10" />
            </a>
          </div>
        )}
        {/* {this.props.viewDataSetIcon && (
          <ul className="viewDataset WidgetActions">
            <li
              title="View Dataset"
              onClick={() => this.ViewDataSet(chartData)}
            >
              <a>
                <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
              </a>
            </li>
          </ul>
        )} */}
        {this.props.flag ? (
          <ul className="WidgetActions">
            {/* <li
              title="View Dataset"
              onClick={() => this.ViewDataSet(chartData)}
            >
              <a>
                <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
              </a>
            </li> */}

            {this.state.editable === false && (
              <>
                {/* <TextNarrative
                chartInputs={chartData}
                selectedDB={this.props.selectedDB}
              /> */}
                {/* <li
                     title="Add to home"
                     onClick={() => this.moveToHome(chartData)}
                   >
                     <a>
                       <img src={Images.HOME} alt="Download" width="14" />
                     </a>
                   </li> */}
                {/* <li onClick={this.handleDownloadImage}>
                <div id="iframe" />
                <a>
                  <img src={Images.DOWNLOAD} alt="Download" width="14" />
                </a>
              </li> */}
                {/* <li onClick={this.textPdf}>
                <a>
                  <img src={Images.PDF} alt="Download" width="14" />
                </a>
              </li>
  
              <li onClick={() => this.openAddToCart(chartData.widgetId)}>
                <a>
                  <img src={Images.SHARE} alt="Download" width="14" />
                </a>
              </li>
  
              <li>
                <Dropdown
                  menuAlign="right"
                  title="Mail"
                  id="dropdown-menu-align-right"
                >
                  <Dropdown.Toggle>
                    <a>
                      <img src={Images.MAIL} alt="Share" width="14" />
                    </a>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="filterList emailBox">
                    <div className="filterBox">
                      <div className="dateRange">
                        <div className="dateCont">
                          <h6>Email</h6>
                          <input
                            type="email"
                            autoComplete="off"
                            value={this.state.emailId}
                            onChange={(e) =>
                              this.setState({
                                emailId: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="dateCont">
                          <h6>Message</h6>
                          <textarea
                            value={this.state.message}
                            autoComplete="off"
                            onChange={(e) =>
                              this.setState({
                                message: e.target.value,
                              })
                            }
                          ></textarea>
                          <Dropdown.Item
                            as="button"
                            onClick={(e) => this.shareFile(e,chartData.widgetId)}
                          >
                            SEND
                          </Dropdown.Item>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li> */}
              </>
            )}

            {chartData.createdBy == userId ||
            (this.props.selectedDashboard &&
              this.props.selectedDashboard.createdBy == userId) ? (
              <>
                {this.props.isFreezeDS ? (
                  ""
                ) : this.state.editable == true ? (
                  <li
                    title="save"
                    onMouseDown={() => this.saveTextWidget(chartData)}
                  >
                    <a>
                      <img src={Images.CHECKGREEN} alt="Save" width="14" />
                    </a>
                  </li>
                ) : (
                  <div style={{display:'flex'}}>
                <li title="Add to home"
                     onClick={() => this.moveToHome(chartData)}
                   >
                     <a>
                       <img src={Images.HOME} alt="Download" width="14" />
                     </a>
                   </li>
                  <li title="Edit" onClick={() => this.toggleEditable(true)}>
                    <a>
                      <img src={Images.EDITICON} alt="Edit" width="14" />
                    </a>
                  </li>
                  
                   </div>
                   
                )}
              </>
            ) : (
              ""
            )}

            {this.props.isTenentAdmin ||
            chartData.createdBy == userId ||
            (this.props.selectedDashboard &&
              this.props.selectedDashboard.createdBy == userId) ? (
              this.props.isFreezeDS ? (
                ""
              ) : (
                 !this.props.isFreezeDS && (
                                     <li onClick={this.openWidgetDeletePopup}>
                                       <a className="bgRed">
                                         <img src={Images.TRASH} alt="Trash" width="13" />
                                       </a>
                                     </li>
                                   )
              )
            ) : (
              ""
            )}
          </ul>
        ) : (
          <ul className="WidgetActions"></ul>
        )}
        <div
          id={"c" + this.state.chartData.widgetId}
          className="textEditorClass"
          style={{ marginTop: "5px" }}
        >
          {/* <small className="createdDate">{CreatedDate}</small> */}
          {/* Chart Here */}
          <Editor
            tools={this.state.editable ? toolsList : []}
            contentStyle={{
              height: 395,
            }}
            style={{
              color: "#FFFFFF",
            }}
            // defaultEditMode={"div"}

            // onBlur={this.openwidgetpopup}
            defaultContent={
              this.state.chartData.textWidgetData ? this.state.chartData.textWidgetData : "<p></p>"
            }
            ref={this._editor}
            onMount={this.onMount}
            onPasteHtml={(event) => {
              let html = pasteCleanup(
                sanitize(event.pastedHtml),
                pasteSettings
              );

              // If the pasted HTML contains images with sources pointing to the local file system,
              // `replaceImageSourcesFromRtf` will extract the sources from the RTF and place them to images 'src' attribute in base64 format.
              if (event.nativeEvent.clipboardData) {
                html = replaceImageSourcesFromRtf(
                  html,
                  event.nativeEvent.clipboardData
                );
              }
              return html;
            }}
          />
         
        </div>

        <Popup
          show={this.state.openDeleteModelFlag}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this report?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.removeWidget(chartData)}
                className="deleteBtn"
                type="button"
              >
                Yes
              </button>
              <button
                onClick={this.closeWidgetDeletePopup}
                className="cancelBtn"
                type="button"
              >
                No
              </button>
            </div>
          </div>
        </Popup>
        {this.state.SaveValue == false ? (
          <Popup show={this.state.autoSave} popupClass={"popup-content"}>
            <div className="deleteModelCont" style={{ width: "676px" }}>
              <h3> Data entered in text report is not saved. Do you want to save changes?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.widgetdata(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closewidgetpopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        ) : null}

        <Popup show={this.state.openPdfTitlePopup} popupClass={"popup-content"}>
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}

          <div className="addTypeForm">
            <div className="fieldCont">
              <label>Enter Title</label>
              <input
                type="text"
                onChange={(e) => this.setState({ title: e.target.value })}
                placeholder="Title"
                value={this.state.title}
                required
              />
            </div>
            <div className="btnGroup">
              <button
                disabled={!this.state.title}
                className="btnPrimary"
                onClick={this.onPDFExportClick}
              >
                Export
              </button>
              <button className="btnDark" onClick={this.pdfTitlePopupClose}>
                Cancel
              </button>
            </div>
          </div>
        </Popup>
        <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
          <AddToCart
            {...this.props}
            closeAddToCart={() => this.closeAddToCart()}
            cartViewDetailsId={this.state.cartViewDetails}
            cartViewType={this.state.cartViewType}
          />
        </Popup>
      </div>
    );
          }
  }
}
